import { connect } from 'react-redux';

import { openCookieSettings } from '../../actions/CookieSettings';

import CookieBanner from '../../components/CookieBanner/CookieBanner';

const mapStateToProps = (state) => ({
    isOpenedSettings: state.cookieSettings.isOpened,
})


const mapDispatchToProps = (dispatch) => ({
    onOpenSettings: () => {
        dispatch(openCookieSettings())
    },
})

export default connect(mapStateToProps, mapDispatchToProps)(CookieBanner)
